import { Line, LineConfig } from '@ant-design/charts'
import React, { useMemo } from 'react'

import { formatPercentage } from '@/utils/formatter'

export interface ChatterPerformanceChartProps {
  data: ChartDataItem[]
  stroke: string
  isSmooth?: boolean
}

export interface ChartDataItem {
  dateStr: string
  name: string
  count: number
}

export type ChartData = ChartDataItem[]

export enum StrokeColors {
  ChatterActivity = '#3A5C40',
  GoldenRatio = '#FFB268',
  UnlockRatio = '#FF887C',
}

export default function ChatterPerformanceChart(
  { data, stroke, isSmooth = true }: ChatterPerformanceChartProps) {
  const config = useMemo(() => {
    const config: LineConfig = {
      data,
      xField: 'dateStr',
      yField: 'count',
      seriesField: 'name',
      colorField: 'name',
      axis: {
        x: {
          labelAutoRotate: false,
        },
      },
      point: {
        zIndex: 2,
        sizeField: 3,
        style: {
          fill: 'white',
          lineWidth: 2,
          stroke,
        },
      },
      shapeField: isSmooth ? 'smooth' : undefined,
      style: {
        lineWidth: 3,
        stroke,
      },
      scale: { color: { range: [stroke] } },
      height: 320,
      tooltip: {
        title: 'dateStr',
        items: [
          (d: (typeof data)[number]) => {
            return { color: stroke, name: d.name, value: formatPercentage()(d.count) }
          },
        ],
      },
      legend: false,
    }

    return config
  }, [data, stroke, isSmooth])

  return <Line {...config} />
}
